import { DTO__number_range } from '@shared/dto/generation/settings/DTO__number_range';
import { ENUM__generation_setting } from '@shared/dto/generation/settings/ENUM__generation_setting';
import { CONSTANTS_GENERATION__slider_step } from './CONSTANTS_GENERATION__slider_step';
import { CONSTANTS_GENERATION__value_range } from './CONSTANTS_GENERATION__value_range';

export class CONSTANTS__generation_settings {
  static readonly PARAMS_STEPS_BEGIN = {
    value: 0,
    value_range: CONSTANTS_GENERATION__value_range.ZERO_TO_ONE,
    values_allowed: CONSTANTS_GENERATION__value_range.ZERO_TO_ONE,
    //
    slider_step: CONSTANTS_GENERATION__slider_step.STEPS_DEFAULT,
    slider_step_values: CONSTANTS_GENERATION__slider_step.STEPS_VALUES,
  };

  static readonly PARAMS_STEPS_END = {
    value: 1,
    value_range: CONSTANTS_GENERATION__value_range.ZERO_TO_ONE,
    values_allowed: CONSTANTS_GENERATION__value_range.ZERO_TO_ONE,
    //
    slider_step: CONSTANTS_GENERATION__slider_step.STEPS_DEFAULT,
    slider_step_values: CONSTANTS_GENERATION__slider_step.STEPS_VALUES,
  };

  static readonly SD_PIPELINE_BATCH_MAIN_SETTINGS_TYPES_SORTED: ENUM__generation_setting[] = [
    ENUM__generation_setting.ML_ASSET_UNET,
    ENUM__generation_setting.ML_ASSET_TEXT_ENCODER,
    ENUM__generation_setting.ML_ASSET_VAE,
    ENUM__generation_setting.SCHEDULER_TYPE,
  ];

  /*
   * GRID2D
   */

  static readonly GRID2D_GENERATION_DIMENSIONS_ALLOWED_TYPES = [
    /*
     * ML ASSET
     */
    ENUM__generation_setting.ML_ASSET_BUNDLE,
    ENUM__generation_setting.ML_ASSET_TEXT_ENCODER,
    ENUM__generation_setting.ML_ASSET_VAE,
    ENUM__generation_setting.ML_ASSET_UNET,
    ENUM__generation_setting.ML_ASSET_IMAGE_ENCODER,
    ENUM__generation_setting.ML_ASSET_IMAGE_PROCESSOR,

    /*
     * IMAGE CANVAS
     */
    ENUM__generation_setting.IMAGE_CANVAS_STRENGTH,
    /*
     * IMAGE CONTROL NET
     */
    ENUM__generation_setting.IMAGE_LINE_GUIDANCE_CONTROL_NET_HASH_SHA256,
    ENUM__generation_setting.IMAGE_LINE_GUIDANCE_CONTROL_NET_STEPS_START,
    ENUM__generation_setting.IMAGE_LINE_GUIDANCE_CONTROL_NET_STEPS_END,
    ENUM__generation_setting.IMAGE_LINE_GUIDANCE_IMAGE_WEIGHT,

    /*
     * IP ADAPTER
     */

    ENUM__generation_setting.IP_ADAPTER_SCALES_ALL,
    ENUM__generation_setting.IP_ADAPTER_SCALE_DOWN,
    ENUM__generation_setting.IP_ADAPTER_SCALE_MIDDLE,
    ENUM__generation_setting.IP_ADAPTER_SCALE_UP,

    ENUM__generation_setting.IP_ADAPTER_IMAGE_WEIGHT,
    /*
     * LORA
     */
    ENUM__generation_setting.LORA_WEIGHT_MASTER,
    ENUM__generation_setting.LORA_WEIGHT,

    /*
     * OTHER
     */
    ENUM__generation_setting.SEED,

    /*
     * SCHEDULER RELATED
     */
    ENUM__generation_setting.INFERENCE_STEPS,
    ENUM__generation_setting.SCHEDULER_TYPE,

    /*
     * TEXT RELATED
     */
    ENUM__generation_setting.TOKEN_WEIGHT,
    ENUM__generation_setting.GUIDANCE_SCALE,
    ENUM__generation_setting.GUIDANCE_RESCALE,
    ENUM__generation_setting.CLIP_SKIP,
  ];

  /*
   * FEATURES
   */

  /*
   * SEED
   */

  static readonly SEEDS_DEFAULT = [19660820, 19881024, 19901104, 19900316, 19901029, 19910801, 19920830, 19950311, 20010424];
  static readonly SEED_GRID2D_DIMENSION_AMOUNT_RANGE = new DTO__number_range(1, 50);
  static readonly SEED_RANGE = new DTO__number_range(0, 2 ** 32);

  static readonly IMAGE_SIZE_MULTIPLIER = 8;
}
